
import ElementUI from 'element-ui'
import Vue from 'vue'
import Report from './modules/project/ui/etl_project/project_detail/ViewReportDetail'
Vue.use(ElementUI)
import JsonViewEditor from 'vue-json-view-editor'
Vue.use(JsonViewEditor)
import { toThousands } from '@/js/utils/filter'
Vue.filter('toThousands',toThousands)
new Vue({
	el: '#report',
	components: { Report },
	template: '<Report/>',
})



// WEBPACK FOOTER //
// ./src/js/report.js